
export const sectionDataTransform = (sectionData) => {
    let data = sectionData.map((item, index, element) => {
        let tempSectionData = Object.assign({});
        tempSectionData.name = item.label;
        tempSectionData.id = item.value;
        tempSectionData.tags = item.tags;
        return tempSectionData;
    })
    return data
}

export const sectionDataListTransform = (sectionData) => {
    let data = sectionData.map((item, index, element) => {
        let tempSectionData = Object.assign({});
        tempSectionData.name = item.section_name;
        tempSectionData.id = item.section_template_id;
        tempSectionData.tags = item.sectionTemplateTags;
        return tempSectionData;
    })
    return data
}


export const crawlerSelectionTransform = (sectionData) => {
    let data = sectionData.map((item) => {
        let tempSectionData = Object.assign({});
        tempSectionData.name = item.label;
        tempSectionData.id = item.value
        return tempSectionData;
    })
    return data
}

export const allSectionIdList = (sectionData) => {
    let idList = sectionData.map((item) => {
        return item.id
    })
    return idList
}

export const validateProductFormData = (productFormData) => {
    let errorList=[];
    if(!productFormData.name){
        errorList.push(" Product Name ");
    }
    if(!productFormData.counterpartyType){
        errorList.push(" Counterparty Type ");
    }
    if(!productFormData.description){
        errorList.push(" Product Description ");
    }
    if(!productFormData.productTitle){
        errorList.push(" Product Title ");
    }
    if(!productFormData.turnAroundTime || productFormData.turnAroundTime==0){
        errorList.push(" Turn Around Time ");
    }
    if(!productFormData.sectionList || productFormData.sectionList.length==0){
        errorList.push(" Report Sections ");
    }
    if(!productFormData.productCategory){
        errorList.push(" Product Category ");
    }
   return errorList;
}